import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import {
  FORGET_PASSWORD,
  ForgetPasswordAction,
  LOGIN,
  LOGOUT,
  LoginAction,
  LogoutAction,
  RESEND_OTP,
  RESET_PASSWORD,
  ResendOTPAction,
  ResetPasswordAction,
  VERIFY_OTP,
  VerifyOTPAction,
} from "./actionTypes";
import {
  forgetPasswordError,
  forgetPasswordSuccess,
  loginError,
  loginSuccess,
  logoutSuccess,
  resendOTPError,
  resendOTPSuccess,
  resetPasswordError,
  resetPasswordSuccess,
  verifyOTPError,
  verifyOTPSuccess,
} from "./actions";

import {
  CreateVerificationRequest,
  ForgetPasswordRequest,
  ResetPasswordRequest,
  ResponseGenerator,
  SigninRequest,
  SignoutRequest,
  VerificationRequest,
} from "../../interfaces";
import {
  signin,
  signout,
  forgetPassword,
  verifyOtp,
  resendOtp,
  resetPassword,
} from "../../helpers/backend_helper";
import { EncryptionService } from "../../services";

function* loginSaga({ payload: { request, history } }: LoginAction) {
  try {
    const response: ResponseGenerator = yield call(
      signin,
      request as SigninRequest
    );
    localStorage.setItem("session", JSON.stringify(response.data));
    yield put(loginSuccess(response.data));
    history.replace("/dashboard");
  } catch (error) {
    yield put(loginError(error));
  }
}

function* logoutSaga({ payload: { request } }: LogoutAction) {
  try {
    yield call(signout, request as SignoutRequest);
    yield put(logoutSuccess());
  } catch (error: any) {
    yield put(logoutSuccess());
  } finally {
  }
}

function* forgetSaga({ payload: { request, history } }: ForgetPasswordAction) {
  try {
    const response: ResponseGenerator = yield call(
      forgetPassword,
      request as ForgetPasswordRequest
    );
    yield put(forgetPasswordSuccess(response.data));
    const phone = request.countryCode + "-" + request.phoneNumber;
    const encPhone = EncryptionService.encrypt(phone);
    history.replace(`/verification/${encPhone}`);
  } catch (error: any) {
    yield put(forgetPasswordError(error));
  } finally {
  }
}

function* verifySage({ payload: { request, history } }: VerifyOTPAction) {
  try {
    const response: ResponseGenerator = yield call(
      verifyOtp,
      request as VerificationRequest
    );
    yield put(verifyOTPSuccess(response.data));
    const phone = request.countryCode + "-" + request.phoneNumber;
    const encPhone = EncryptionService.encrypt(phone);
    const encCode = EncryptionService.encrypt(request.code as string);
    history.replace(`/reset-password/${encPhone}/${encCode}`);
  } catch (error: any) {
    yield put(verifyOTPError(error));
  } finally {
  }
}

function* resendSaga({ payload: { request } }: ResendOTPAction) {
  try {
    const response: ResponseGenerator = yield call(
      resendOtp,
      request as CreateVerificationRequest
    );
    yield put(resendOTPSuccess(response.data));
  } catch (error: any) {
    yield put(resendOTPError(error));
  } finally {
  }
}

function* resetSaga({ payload: { request, history } }: ResetPasswordAction) {
  try {
    const response: ResponseGenerator = yield call(
      resetPassword,
      request as ResetPasswordRequest
    );
    yield put(resetPasswordSuccess(response.data));
    history.replace(`/login`);
  } catch (error: any) {
    yield put(resetPasswordError(error));
  } finally {
  }
}

function* authSaga() {
  yield takeEvery(LOGIN, loginSaga);
  yield takeEvery(LOGOUT, logoutSaga);
  yield takeEvery(FORGET_PASSWORD, forgetSaga);
  yield takeEvery(VERIFY_OTP, verifySage);
  yield takeEvery(RESEND_OTP, resendSaga);
  yield takeEvery(RESET_PASSWORD, resetSaga);
}

export default authSaga;
